type VehicleInformation = {
  mileage: number | null
  fre: string | null
  dateCreationDossier: string | null
  registrationCertificateReceivedDate: string | null
  receiptDate: string | null
  stockInElapsedDays: number | null
  observationsVendeur: string | null
  noteExt: number | null
  noteInt: number | null
  noteCT: number | null
  noteBilanExpert: number | null
}
const defaultVehicleInformation: VehicleInformation = {
  mileage: null,
  fre: null,
  dateCreationDossier: null,
  registrationCertificateReceivedDate: null,
  receiptDate: null,
  stockInElapsedDays: null,
  observationsVendeur: null,
  noteExt: null,
  noteInt: null,
  noteCT: null,
  noteBilanExpert: null,
}

export type { VehicleInformation }
export { defaultVehicleInformation }
